module.exports = __webpack_public_path__ + "img/ls4.98b3e9d5.webp";